import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_PREFIX, filtersToParams, RESOURCES } from 'rio-core';
import { PromptChain, PromptChainResponse, SelectedFilters } from 'rio-models';
import { map, Observable } from 'rxjs';
import { PromptChainsResponse } from './models';

@Injectable()
export class PromptChainsService {
  API_PREFIX = inject(API_PREFIX);
  httpClient = inject(HttpClient);

  getPromptChains(organizationId: string, filters?: SelectedFilters): Observable<PromptChain[]> {
    const url = `${this.API_PREFIX}${RESOURCES.CHAINS.chains(organizationId)}`;

    const params = filtersToParams(filters);

    return this.httpClient
      .get<PromptChainsResponse>(url, { params })
      .pipe(map(response => response.chains.map(this.chainAdapter)));
  }

  private chainAdapter(chain: PromptChainResponse): PromptChain {
    return {
      type: 'chain',
      id: chain.id,
      name: chain.name,
      categories: chain.categories,
      isActive: chain.is_active,
      prompts: chain.prompts.map(prompt => ({ promptId: prompt.prompt_id, contextType: prompt.context_type })),
      lastEdited: chain.last_edited,
      lastUsed: chain.last_used,
      usage: chain.usage,
    };
  }
}
